/* eslint-disable class-methods-use-this */
import PATH from "constants/path";
import axios from "axios";
import { clearLocalStorage, returnCommom, saveInfoLocal } from "utils/common";
import { setLoading } from "utils/core";

const MAX_CONTENT_LENGTH = 100000000;
const TIMEOUT = 1200000;
const CONTENT_TYPE = {
  FORM: "multipart/form-data",
  JSON: "application/json",
};

export default class RequestMgr {
  static instance = null;

  static createInstance() {
    const object = new RequestMgr();
    return object;
  }

  static getInstance() {
    if (!RequestMgr.instance) {
      RequestMgr.instance = RequestMgr.createInstance();
    }
    return RequestMgr.instance;
  }

  // variables
  isGetNewToken = false;

  accessToken = "";

  recentToken = "";

  recentNewToken = "";

  prevRequest = 0;

  currentRequest = 0;

  refreshTimes = 0;

  getUrl(url) {
    let domain = process.env.REACT_APP_MONITOR_API_END_POINT;
    const lastCharacter = domain.charAt(domain.length - 1);
    if (lastCharacter !== "/") domain += "/";
    return `${domain}${url}`;
  }

  getOrigin() {
    return window.location.origin;
  }

  getId() {
    return new Date().getTime();
  }

  errorFormater({ data, status }) {
    return { data, status };
  }

  setLoading(increase) {
    setLoading(increase);
  }

  forbidden(returnError = true) {
    setLoading(false);
    if (returnError) {
      clearStorage();
      window.location.replace("#" + PATH.ERROR_403);
    }
    return;
  }

  manyRequest() {
    window.location.replace("#" + PATH.ERROR_429);
    setLoading(false);
    return;
  }

  error() {
    window.location.replace("#" + PATH.ERROR_500);
    setLoading(false);
    return;
  }

  sorryPage() {
    window.location.replace("#" + PATH.ERROR_512);
    setLoading(false);
    return;
  }

  logout(returnError = true) {
    if (returnError) {
      clearLocalStorage();
      location.href = PATH.TOP;
    }
    return;
  }

  notfound(returnError = true) {
    setLoading(false);
    if (returnError) {
      window.location.replace("#" + PATH.ERROR_404);
    }
  }

  setLoading(increase) {
    setLoading(increase);
  }

  validateResponse(response) {
    saveInfoLocal(response);
    if (response === undefined || response === null || response === "") {
      return { status: 200 };
    }
    return response;
  }

  async doRequest(
    method,
    url,
    {
      data,
      params,
      headers,
      isUpload,
      noAuth,
      noDomain,
      noLoading,
      returnError,
      ...arg
    } = {}
  ) {
    let validAccessToken = "";
    try {
      const reqHeader = {
        "Content-Type": isUpload ? CONTENT_TYPE.FORM : CONTENT_TYPE.JSON,
        Accept: "*/*",
        ...headers,
      };
      if (!noAuth) {
        try {
          const auth = JSON.parse(localStorage.getItem("AUTH"));

          let expiresDate = new Date(auth.expires_date);
          let todaysDate = new Date();

          // check expired
          if (todaysDate >= expiresDate) {
            clearLocalStorage();
            // return COMMON get token
            returnCommom();
          } else {
            validAccessToken = auth?.access_token;
          }
        } catch (error) {
          validAccessToken = "";
        }

        if (validAccessToken)
          reqHeader.Authorization = `Bearer ${validAccessToken}`;
      }

      const reqConfig = {
        method,
        url: noDomain ? url : this.getUrl(url),
        params,
        headers: reqHeader,
        timeout: TIMEOUT,
        maxContentLength: MAX_CONTENT_LENGTH,
        ...(data && { data: !isUpload ? JSON.stringify(data) : data }),
        ...arg,
      };
      if (!noLoading) this.setLoading(true);
      const response = await axios.request(reqConfig);
      if (!noLoading) this.setLoading(false);
      return this.validateResponse(response.data);
    } catch (error) {
      if(error.response === undefined) {
        this.setLoading(false);
        return this.validateResponse({ data: { notice: { data: [] }, isInLine: true }, isInLine: true });
      }
      const { status } = error.response;
      this.setLoading(false);
      switch (true) {
        case status === 401:
          this.logout(returnError);
          break;
        case status === 403:
          this.forbidden();
          break;
        case status === 404:
          this.notfound(returnError);
          break;
        case status === 429:
          this.manyRequest();
          break;
        case status === 500:
          this.error();
          break;
        case status === 512:
          this.sorryPage();
          break;
        default:
      }
      throw this.errorFormater({ data: error.response?.data, status });
    }
  }
}
